import Dropdown, { dropdownTriggerClassname } from "app/components/Dropdown";
import { Menu } from "app/components/Icons";
import ArchiveIcon from "app/components/Icons/ArchiveIcon";
import { DuplicateIcon } from "app/components/Icons/DuplicateIcon";
import clsx from "clsx";
import React from "react";

interface Props {
  onArchive: () => void;
  onDuplicate: () => void;
  showActions: boolean;
  setShowActions: React.Dispatch<React.SetStateAction<boolean>>;
}

const ColumnOptionsMenu: React.FC<Props> = ({
  onArchive,
  onDuplicate,
  setShowActions,
  showActions,
}) => {
  const rowOptions = [
    {
      label: "Duplicate",
      icon: <DuplicateIcon size={20} color="#79808A" />,
      actions: onDuplicate,
    },
    {
      label: "Archive",
      icon: <ArchiveIcon size={20} color="#79808A" />,
      actions: onArchive,
    },
  ];
  return (
    <div className="relative ">
      <Dropdown
        open={showActions}
        setOpen={() => setShowActions(!showActions)}
        trigger={
          <button
            className={clsx(
              "flex items-center justify-center items-center rounded w-[16px] h-[16px] h-full data-[state=open]:border-secondary data-[state=open]:outline-secondary data-[state=open]:border-[1px] border-secondary outline-[0px] focus:outline-[0px]",
              
            )}
          >
            <Menu size="16" color="#79808A" />
          </button>
        }
        menuItems={rowOptions?.map((ele) => {
          if (ele)
            return {
              label: (
                <div className="flex items-center justify-between gap-1.5  transition-colors">
                  <div className="flex items-center gap-[4px]  ">
                    {ele.icon}
                    <span className="text-sm font-normal text-black">
                      {ele.label}
                    </span>
                  </div>
                </div>
              ),
              action: () => {
                ele.actions();
              },
            };
          else return { label: "", action: () => {} };
        })}
        align="start"
      />
    </div>
  );
};

export default ColumnOptionsMenu;
